module.exports = __webpack_public_path__ + "static/img/Dbz-Dabozz.580edcc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/card/Dbz-Dabozz.jpg
// module id = K493
// module chunks = 1